import MarketingBanner from './MarketingBanner';

export default MarketingBanner;
